import { FormRow, FormSection } from 'framework/ui/layout';
import { AdditionalContactListInput } from 'domain/shared/contact';
import { FC } from 'react';
import { PhoneInput, TextInput } from 'framework/form';

const ContactInfoSection: FC = () => {
  return (
    <FormSection title="Contact information">
      <FormRow>
        <PhoneInput source="extendedInformation.personalPhoneNumber" label="Personal phone number" />
        <TextInput source="extendedInformation.personalEmail" label="Personal email address" />
        <PhoneInput source="extendedInformation.otherPhoneNumber" label="Other phone number" />
      </FormRow>

      <AdditionalContactListInput source="extendedInformation.additionalContactInfo" />
    </FormSection>
  );
};

export { ContactInfoSection };
